import React, { useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Check, Sparkles, Lock } from "lucide-react";
import { toast } from "sonner";

export default function ProUpgradeCard({ onUpgraded }) {
  const [loading, setLoading] = useState(false);
  const features = [
    "AI Alpha Signals (12 ranked edges, refreshed every minute)",
    "Claude-generated trade rationales",
    "Unlimited bot creations",
    "Up to 300 trades/min per bot",
    "Priority support",
  ];

  async function upgrade() {
    setLoading(true);
    try {
      const r = await api.post("/billing/checkout", {
        package_id: "pro_monthly",
        origin_url: window.location.origin,
      });
      window.location.href = r.data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to start checkout");
      setLoading(false);
    }
  }

  return (
    <div className="relative overflow-hidden border border-[#007AFF]/40 bg-gradient-to-br from-[#0F1722] to-[#0F0F0F] p-8" data-testid="pro-upgrade-card">
      <div className="absolute -top-12 -right-12 w-40 h-40 bg-[#007AFF]/10 rounded-full blur-3xl pointer-events-none" />
      <div className="relative">
        <div className="flex items-center gap-2">
          <Lock size={14} className="text-[#FFB300]" />
          <span className="label-xs">Pro feature</span>
        </div>
        <div className="flex items-end gap-3 mt-2 mb-1">
          <h2 className="text-4xl font-[Chivo] tracking-tight">Unlock Alpha Signals</h2>
          <Sparkles size={22} className="text-[#FFB300] mb-2" />
        </div>
        <p className="text-neutral-400 max-w-2xl">
          Get the AI-distilled edge from every paper &amp; live bot on the platform. Trade with confidence backed by aggregate data + Claude reasoning.
        </p>

        <div className="mt-6 flex items-end gap-2">
          <span className="text-5xl font-[Chivo] num">$29</span>
          <span className="text-neutral-400 mb-2 num">/ 30-day pass</span>
        </div>

        <ul className="mt-6 space-y-2">
          {features.map((f) => (
            <li key={f} className="flex items-start gap-2 text-sm">
              <Check size={16} className="text-[#00E676] mt-0.5 shrink-0" />
              <span className="text-neutral-200">{f}</span>
            </li>
          ))}
        </ul>

        <Button
          data-testid="upgrade-to-pro"
          onClick={upgrade}
          disabled={loading}
          className="mt-7 bg-[#007AFF] hover:bg-[#3395FF] text-white font-[Chivo] tracking-wide w-full lg:w-auto px-8"
        >
          {loading ? "Redirecting to Stripe…" : "Upgrade to Pro — $29"}
        </Button>

        <p className="mt-3 text-xs text-neutral-500">
          Secure payment via Stripe. Test mode active — no real card will be charged.
        </p>
      </div>
    </div>
  );
}
